module.exports = __webpack_public_path__ + "img/97.a672af0e.gif";